<script lang="ts">
    import { scrollIsLocked } from '@amp/web-app-components/src/stores/scroll-is-locked';
    import { openDrawer } from '~/stores/open-drawer';
</script>

<slot scrollIsLocked={$scrollIsLocked} isOpenDrawer={!!$openDrawer} />
